import axios from 'axios';

// Get environment variables for Kitchen & Bar API
const KITCHEN_BASE_URL = process.env.REACT_APP_KITCHEN_BASE_URL || 'http://localhost/kitchen';

// Construct API endpoints
const KITCHEN_ITEMS_URL = `${KITCHEN_BASE_URL}${process.env.REACT_APP_KITCHEN_ITEMS_PATH || '/api/items.php'}`;
const KITCHEN_ORDER_URL = `${KITCHEN_BASE_URL}${process.env.REACT_APP_KITCHEN_ORDER_PATH || '/api/kitchen_order.php'}`;

// Fetch available kitchen items
export const fetchKitchenItems = async () => {
  try {
    const response = await axios.get(KITCHEN_ITEMS_URL);
    return response.data;
  } catch (error) {
    console.error('Error fetching kitchen items:', error);
    throw error;
  }
};

// Submit kitchen order with payment info in a single request
export const submitKitchenOrder = async (orderData) => {
  try {
    // orderData should contain:
    // - items: array of { uuid, name, quantity, unit_price }
    // - customer: { name, email, mpesaNumber, seatNumber, screen }
    const response = await axios.post(KITCHEN_ORDER_URL, orderData);
    return response.data;
  } catch (error) {
    console.error('Error submitting kitchen order:', error);
    throw error;
  }
};
